import React, { useContext } from 'react';
import { API_BASE_URL } from '../api/axios';
import { PlayerPeekContext } from '../context/PlayerPeekContext';

const API_BASE = API_BASE_URL;

function DefaultAvatar({ sizeClass }) {
  return (
    <div
      className={`${sizeClass} rounded-full flex-shrink-0 border-2 overflow-hidden`}
      style={{ borderColor: 'rgba(245,197,24,0.4)', background: 'linear-gradient(160deg, #1c2233 0%, #111827 100%)' }}
    >
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <circle cx="50" cy="37" r="18" fill="#2d3a4f" />
        <ellipse cx="50" cy="82" rx="28" ry="20" fill="#2d3a4f" />
      </svg>
    </div>
  );
}

export function Avatar({ name, avatar, size = 'md', playerId }) {
  const peekCtx = useContext(PlayerPeekContext);
  const sizes = {
    xs: 'w-8 h-8',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20',
  };

  let inner;
  if (avatar) {
    inner = (
      <img
        src={`${API_BASE}/uploads/${avatar}`}
        alt={name || 'avatar'}
        className={`${sizes[size]} rounded-full object-cover flex-shrink-0 border-2`}
        style={{ borderColor: 'rgba(245,197,24,0.4)' }}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    );
  } else {
    inner = <DefaultAvatar sizeClass={sizes[size]} />;
  }

  if (playerId != null && peekCtx?.openPeek) {
    return (
      <span
        role="button"
        tabIndex={0}
        className="inline-flex rounded-full cursor-pointer transition-transform active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/50"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          peekCtx.openPeek(playerId);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            peekCtx.openPeek(playerId);
          }
        }}
      >
        {inner}
      </span>
    );
  }

  return inner;
}

export function Badge({ rank }) {
  if (rank === 1) return <span className="text-xl">🥇</span>;
  if (rank === 2) return <span className="text-xl">🥈</span>;
  if (rank === 3) return <span className="text-xl">🥉</span>;
  return <span className="text-text-secondary font-bold text-sm">#{rank}</span>;
}

export function StatCard({ label, value, icon, color = 'accent' }) {
  const colors = {
    accent: 'text-accent',
    success: 'text-success',
    danger: 'text-danger',
    blue: 'text-blue-400',
  };
  return (
    <div className="glass-card p-4 text-center">
      {icon && <div className="flex justify-center mb-2 text-text-secondary">{icon}</div>}
      <div className={`text-2xl font-bold ${colors[color] || colors.accent}`}>{value}</div>
      <div className="text-text-secondary text-sm mt-1">{label}</div>
    </div>
  );
}

export function ScoreBoard({ player1, score1, player2, score2, avatar1, avatar2, proposed, player1Id, player2Id }) {
  return (
    <div className="glass-card p-6">
      {proposed && (
        <div className="text-center mb-4 text-xs font-medium px-3 py-1.5 rounded-full inline-block"
          style={{ background: 'rgba(245,197,24,0.15)', color: '#F5C518', border: '1px solid rgba(245,197,24,0.3)' }}>
          ⏳ نتيجة مقترحة — بانتظار التأكيد
        </div>
      )}
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col items-center gap-2 flex-1">
          <Avatar name={player1} avatar={avatar1} size="lg" playerId={player1Id} />
          <span className="font-semibold text-center text-sm text-white">{player1}</span>
        </div>
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-3">
            <span className="text-5xl font-black text-accent">{score1}</span>
            <span className="text-text-secondary text-2xl font-light">:</span>
            <span className="text-5xl font-black text-accent">{score2}</span>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 flex-1">
          <Avatar name={player2} avatar={avatar2} size="lg" playerId={player2Id} />
          <span className="font-semibold text-center text-sm text-white">{player2}</span>
        </div>
      </div>
    </div>
  );
}
